import { categories } from "@/mocks/events";

export default function Categories() {
  return (
    <section id="categories" className="bg-background-100/70 py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="text-center">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-secondary-100 px-3 py-1 text-xs font-bold text-secondary-800">
            <i className="ri-apps-2-line text-sm"></i>
            主题分类
          </span>
          <h2 className="mt-3 font-heading text-2xl font-black text-foreground-950 md:text-3xl">你想吃的瓜都在这里</h2>
          <p className="mx-auto mt-2 max-w-2xl text-sm text-foreground-600">
            我们按主题划分内容，方便你快速找到感兴趣的领域。
          </p>
        </div>

        <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {categories
            .filter((c) => c.key !== "all")
            .map((c) => (
              <a
                key={c.key}
                href="#timeline"
                className="group flex items-start gap-4 rounded-2xl border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-200"
              >
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-primary-100 text-primary-600 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                  <i className={`${c.icon} text-xl`}></i>
                </span>
                <div>
                  <h3 className="font-heading text-base font-extrabold text-foreground-950">{c.name}</h3>
                  <p className="mt-1 text-sm text-foreground-600">{c.desc}</p>
                </div>
              </a>
            ))}
        </div>
      </div>
    </section>
  );
}